/* Pickeasy default fulfilment v5: Standard Shipping default (remembered) + slot picker hidden for shipping + mixed-cart guard (click-collect items cannot be mixed with other items). */
(function () {
  var KEY = 'stj_fulfilment_pref';
  var TAG = 'click-collect';
  var seen = new WeakSet();
  var scheduled = false;

  function getPref() {
    try { return localStorage.getItem(KEY) === 'pickup' ? 'pickup' : 'shipping'; }
    catch (e) { return 'shipping'; }
  }
  function setPref(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }
  function widgetOf(container) {
    return container.closest('pickeasy-app-widget') || container.parentElement || document;
  }
  function slotPickerReady(w) {
    return !!w.querySelector('pickeasy-slot-picker.hydrated');
  }
  function fire(el, type) {
    var Ctor = (type.indexOf('pointer') === 0 && window.PointerEvent) ? PointerEvent : MouseEvent;
    el.dispatchEvent(new Ctor(type, { bubbles: true, cancelable: true, view: window, button: 0, pointerType: 'mouse' }));
  }
  function realClick(tile) {
    var target = tile.querySelector('.label-container') || tile;
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) { fire(target, t); });
  }

  /* Keep the slot picker hidden while Standard Shipping is the active tile. */
  function enforce(w) {
    var sp = w.querySelector('pickeasy-slot-picker');
    if (!sp) return;
    var ship = w.querySelector('.ft-options[data-option="shipping"]');
    var shipActive = !!ship && ship.classList.contains('ft-options-active');
    var hiddenNow = sp.style.getPropertyValue('display') === 'none' && sp.style.getPropertyPriority('display') === 'important';
    if (shipActive) {
      if (!hiddenNow) {
        sp.style.setProperty('display', 'none', 'important');
        sp.setAttribute('data-stj-hidden', '1');
      }
    } else if (sp.hasAttribute('data-stj-hidden')) {
      sp.style.removeProperty('display');
      sp.removeAttribute('data-stj-hidden');
    }
  }
  function enforceAll() {
    document.querySelectorAll('pickeasy-app-widget').forEach(enforce);
  }

  /* Select the remembered option (default: shipping) on each new widget. */
  function apply(container) {
    var want = getPref();
    var w = widgetOf(container);
    var waits = 0, clicks = 0;
    (function attempt() {
      if (!document.contains(container)) return;
      var tile = container.querySelector('.ft-options[data-option="' + want + '"]');
      if (!tile) return;
      if (tile.classList.contains('ft-options-active')) return;
      if (!slotPickerReady(w)) {
        if (++waits > 80) { console.warn('[stj] slot picker never hydrated'); return; }
        setTimeout(attempt, 250);
        return;
      }
      if (++clicks > 8) { console.warn('[stj] Pickeasy default selection did not apply'); return; }
      realClick(tile);
      setTimeout(attempt, 450);
    })();
  }
  function scan() {
    document.querySelectorAll('#ft-options-div').forEach(function (c) {
      if (seen.has(c)) return;
      seen.add(c);
      c.addEventListener('click', function (e) {
        if (!e.isTrusted) return;
        var t = e.target.closest('.ft-options');
        if (t && t.dataset.option) setPref(t.dataset.option);
      });
      setTimeout(function () { apply(c); }, 300);
    });
  }

  /* ---------- Mixed cart guard ---------- */
  var tagCache = {};
  var mixed = false;
  var collectTitles = [];
  var otherTitles = [];
  var lastCheck = 0;
  var checking = false;

  function isCollectOnly(handle) {
    if (!tagCache[handle]) {
      tagCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          return p ? (p.tags || []).some(function (t) { return String(t).toLowerCase() === TAG; }) : null;
        })
        .catch(function () { delete tagCache[handle]; return null; });
    }
    return tagCache[handle];
  }
  function isCheckoutControl(el) {
    if (el.matches('[name="checkout"]')) return true;
    var txt = String(el.value || el.textContent || '').replace(/\s+/g, ' ').trim();
    return /^check\s?out$/i.test(txt);
  }
  function checkoutControls() {
    return Array.prototype.filter.call(document.querySelectorAll('button, input[type="submit"], a'), isCheckoutControl);
  }

  function renderGuard() {
    var controls = checkoutControls();
    controls.forEach(function (el) {
      if (mixed && !el.hasAttribute('data-stj-blocked')) {
        el.setAttribute('data-stj-blocked', '1');
        el.setAttribute('aria-disabled', 'true');
        el.style.opacity = '0.4';
        el.style.pointerEvents = 'none';
        if ('disabled' in el) el.disabled = true;
      } else if (!mixed && el.hasAttribute('data-stj-blocked')) {
        el.removeAttribute('data-stj-blocked');
        el.removeAttribute('aria-disabled');
        el.style.opacity = '';
        el.style.pointerEvents = '';
        if ('disabled' in el) el.disabled = false;
      }
    });
    var anchors = Array.prototype.slice.call(document.querySelectorAll('pickeasy-app-widget'));
    if (!anchors.length && controls.length) anchors = [controls[0]];
    anchors.forEach(function (a) {
      var prev = a.previousElementSibling;
      var box = (prev && prev.classList && prev.classList.contains('stj-mixed-warning')) ? prev : null;
      if (mixed) {
        if (!box) {
          box = document.createElement('div');
          box.className = 'stj-mixed-warning';
          box.setAttribute('role', 'alert');
          box.style.cssText = 'border:1px solid #000;padding:12px;margin:12px 0;font-size:14px;line-height:1.4;background:#fff;';
          a.parentNode.insertBefore(box, a);
        }
        var sig = collectTitles.join('|') + '#' + otherTitles.join('|');
        if (box.getAttribute('data-sig') !== sig) {
          box.setAttribute('data-sig', sig);
          box.textContent = '';
          var p1 = document.createElement('p');
          p1.style.cssText = 'margin:0 0 6px;font-weight:bold;';
          p1.textContent = 'Click & collect items must be ordered separately from other items.';
          var p2 = document.createElement('p');
          p2.style.margin = '0';
          p2.textContent = 'Collection only: ' + collectTitles.join(', ') + '. Other items: ' + otherTitles.join(', ') + '. Please remove one set to continue.';
          box.appendChild(p1);
          box.appendChild(p2);
        }
      } else if (box) {
        box.remove();
      }
    });
  }

  function checkCart() {
    if (checking || Date.now() - lastCheck < 1000) return;
    checking = true;
    lastCheck = Date.now();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        return Promise.all(items.map(function (i) { return isCollectOnly(i.handle); })).then(function (flags) {
          if (flags.indexOf(null) > -1) return; // lookup failed: never block on uncertainty
          var c = [], o = [];
          items.forEach(function (i, n) { (flags[n] ? c : o).push(i.product_title || i.title); });
          mixed = c.length > 0 && o.length > 0;
          collectTitles = c;
          otherTitles = o;
          renderGuard();
        });
      })
      .catch(function () {})
      .then(function () { checking = false; });
  }

  document.addEventListener('click', function (e) {
    if (!mixed || !e.target.closest) return;
    var el = e.target.closest('button, input[type="submit"], a');
    if (el && isCheckoutControl(el)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {
    if (mixed && e.submitter && isCheckoutControl(e.submitter)) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  function run() { scheduled = false; scan(); enforceAll(); renderGuard(); checkCart(); }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(run); } }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
  });
  setInterval(function () { enforceAll(); checkCart(); }, 2500);
  schedule();
})();